<script>
  import RadialInterface from "./RadialInterface.svelte";
</script>

<section class="section-03" id="case-studies">
  <div class="about-container">
    <h4 class="title">
      Designing and maintaining <br /> meaningful User experiences
    </h4>

    <div class="svg-padding">
      <svg
        width="30"
        height="1"
        viewBox="0 0 30 1"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line y1="0.5" x2="30" y2="0.5" stroke="white" />
      </svg>
    </div>
    <div class="about-text">
    
Over the past five years, I've been on a mission, collaborating in both MNCs and government services to provide essential design and technological expertise. 
<br><br> This journey has seen me contribute significantly to a diverse array of projects, from small gamification tasks to the development of comprehensive Design Systems. 
<br> <br> Throughout, my role has been purposefully focused on driving innovation through prototyping, user experience design, research, and design operations.
    </div>
    <br />

    <div class="svg-padding">
      <svg
        width="1"
        height="40"
        viewBox="0 0 1 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line x1="0.5" y1="2.18557e-08" x2="0.499995" y2="120" stroke="white" />
      </svg>
    </div>
  </div>
</section>

<style>
  section {
    height: auto;
    padding-top: 100px;
  }
  .title {
    display: flex;
    flex-direction: column;
    position: relative;
    height: 100%;
    top: 10px;
    text-align: center;
    color: white;
    margin-bottom: 20px;
  }
  .about-text {
    max-width: 600px;
    font-weight: 200;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: white;
    margin: auto;
    font-family: "Barlow", sans-serif;
  }
  .about-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  section.section-03 {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "Barlow";
    font-style: normal;
  }
  @media only screen and (max-width: 800px) {
    .about-container {
      display: flex;
      height: 100%;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      padding: 20px;
    }

    .about-text {
      margin: auto;
      width: calc(100vw - 80px);
    }
  }
</style>
